import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {AuthenticationService} from '../services/authentication.service';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {HttpAbstract} from '../abstract/http.abstract';

@Injectable()
export class ErrorInterceptor extends HttpAbstract implements HttpInterceptor {

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError(err => {
          if ([401, 403].includes(err.status) && this.authenticationService.currentUserValue) {
            // auto logout if 401 or 403 response returned from api
            this.authenticationService.logout();
            location.reload();
          }
          return super.handleError(err);
        })
      )
  }
}
